/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_CopiedInputs */

const vi_toast_copied = /** @type {(inputs: Toast_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã sao chép`)
};

/**

* @param {Toast_CopiedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_copied = /** @type {((inputs?: Toast_CopiedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_CopiedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_copied(inputs)
});